<template>
    <div class="story-maker-sticker story-maker-sticker-music-facebook edit" v-if="isEditing">

        <p class="text-finish" @click="finish">{{ $t('dash.post-creator.story.done') }}</p>
        <i class="fa-solid fa-trash trash" @click="deleteMusic"></i>

        <div class="container-options">
            <CursorMusic
                :music="music"
                :defaultRangeDuration="models.rangeDuration"
                :defaultStart="models.start"
                @rangeDurationChange="models.rangeDuration = $event"
                @startChange="models.start = $event"
            />
        </div>
    </div>
</template>

<script>

import CursorMusic from '../../../cursorMusic.vue';
import { EventBus } from '@/event-bus';

export default {
    components: {
        CursorMusic,
    },

    props: {
        id: [Number, String],
        music: Object,
        styleVariant: {
            type: Number,
            default: 1
        },
        start: Number,
        rangeDuration: Number,
        isEditing: Boolean,
    },

    data() {
        return {
            models : {
                rangeDuration: this.rangeDuration ? this.rangeDuration.toString() : '15000',
                start: this.start || 0,
            }
        }
    },

    mounted () {
        EventBus.$on('storyMaker-confirmEditingSticker', this.saveCurrentState);
    },

    beforeDestroy() {
        EventBus.$off('storyMaker-confirmEditingSticker', this.saveCurrentState);
    },

    methods: {
        saveCurrentState() {
            if (!this.isEditing) return;
            this.$emit('updateSticker', this.id, {
                isEditing: false,
                data: {
                    music: this.music,
                    rangeDuration: Math.min(45000, parseInt(this.models.rangeDuration)),
                    start: this.models.start,
                    styleVariant: this.styleVariant,
                }
            });
        },

        finish() {
            this.saveCurrentState();
        },

        deleteMusic() {
            this.$emit('deleteSticker', this.id)
        }
    },
}
</script>
